import {Box, Button, Card, Icon} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {ValidatorForm} from "react-material-ui-form-validator";
import {connect} from "react-redux";
import {NavLink, useRouteMatch} from "react-router-dom";
import defaultUser from "../../../../assets/user.png";
import AdminForm from "../../../../components/AdminForm/AdminForm";
import AppBreadCrumb from "../../../../components/AppBreadCrumb/AppBreadCrumb";
import ConfirmationDialog from "../../../../utilities/components/ConfirmationDialog/ConfirmationDialog";
import {APP_URLS, ROLES} from "../../../../utilities/constants";
import {dataURLtoFile} from "../../../../utilities/utilityFunctions";
import UtilHelper from "../../../../utilities/validators/UtilHelper";
import {
  addAdminFromExistingUserRequest,
  addAdminRequest,
  getSignedUrlRequest,
  getUserByEmailRequest,
  uploadToS3Request,
} from "../../AdministratorsApiActions";
import {useStyles} from "./styles";

/**
 * function to render admin form
 * @param location: location from router
 * @returns {JSX.Element}
 * @constructor
 */
const AdminFormForOrgAdmin = ({
                                location,
                                history,
                                getUserByEmail,
                                addAdmin,
                                addAdminFromExistingUser,
                                getSignedUrl,
                                uploadToS3,
                              }) => {
  const classes = useStyles();
  const match = useRouteMatch();

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [userid, setUserid] = useState("");
  const [openCancelConfirmation, setOpenCancelConfirmation] = useState(false);
  const [rowImageFile, setRowImageFile] = useState(null);
  const [cropper, setCropper] = useState(null);
  const [croppedImageFile, setCroppedImageFile] = useState(null);
  const [showImageEditor, setShowImageEditor] = useState(false);
  const currentUrlPath = match.path.split(":")[0];

  useEffect(() => {
    ValidatorForm.addValidationRule("isBlank", (value) =>
      UtilHelper.validateBlankSpace(value)
    );
    ValidatorForm.addValidationRule("isValidMobile", (value) =>
      UtilHelper.validateMobile(value)
    );
    ValidatorForm.addValidationRule("isMaxLength", (value) =>
      UtilHelper.validateMaxLength(value)
    );
    // Add this new validation rule
    ValidatorForm.addValidationRule("noSpecialChars", (value) =>
      /^[a-zA-Z\s]*$/.test(value)
    );

    return () => {
      ValidatorForm.removeValidationRule("isBlank");
      ValidatorForm.removeValidationRule("isValidMobile");
      ValidatorForm.removeValidationRule("isMaxLength");
      ValidatorForm.removeValidationRule("noSpecialChars");
    };
  }, []);

  const breadCrumbDataForAddOrgAdminForm = [
    {
      icon: "business",
      name: "Clinics",
      path: APP_URLS.ORGANIZATIONS,
    },
    {
      name: `${
        location.state && location.state
          ? `${location.state.orgNameHistory}`
          : ""
      }`,
      path: `${APP_URLS.ORGANIZATIONS}/${
        location.state && location.state.orgIdHistory
      }`,
    },
    {
      name: `Add Administrator`,
      path: APP_URLS.ORGANIZATIONS_ADD_ADMIN,
    },
  ];

  /**
   * function to get breadcrumb data for current url
   * @returns {[{path: string, icon: OverridableComponent<SvgIconTypeMap>, name: string}, {path: string, name: string}, {path: string, name: string}]|*[]|[{path: string, icon: OverridableComponent<SvgIconTypeMap>, name: string}, {path: string, name: string}, {path: string, name: string}, {path: string, name: string}]}
   */

  const getBreadcrumbData = () => {
    return breadCrumbDataForAddOrgAdminForm;
  };

  /**
   * function to handle search by email upon email input
   */
  const handleSearchUserByEmail = () => {
    if (email) {
      getUserByEmail(email).then(
        (res) => {
          setUserid(res.id);
          setCroppedImageFile(res.imageUrl ? res.imageUrl : defaultUser);
          setFirstname(res.firstName);
          setLastname(res.lastName);
          setPhone(res.phone);
          setIsDisabled(true);
        },
        () => {
          setCroppedImageFile(null);
          setFirstname("");
          setLastname("");
          setPhone("");
          setIsDisabled(false);
        }
      );
    } else {
      setCroppedImageFile(null);
      setFirstname("");
      setLastname("");
      setPhone("");
      setIsDisabled(false);
    }
  };

  /**
   * function to handle image crop
   */
  const onImageCrop = () => {
    const croppedImageDataUrl = cropper.getCroppedCanvas().toDataURL();
    const croppedImageFileObject = dataURLtoFile(
      croppedImageDataUrl,
      rowImageFile[0].file.name
    );

    const data = {
      dataURL: croppedImageDataUrl,
      file: croppedImageFileObject,
    };

    setCroppedImageFile(data);
    setShowImageEditor(false);
  };

  /**
   * function to add admin on button click
   * @param e: event from button click
   */
  const onAdd = (e) => {
    e.preventDefault();

    const data = {
      organizationId: location.state.orgIdHistory,
      user: {
        email: email,
        phone: phone,
        firstName: firstname,
        lastName: lastname,
        roles: [ROLES.ROLE_ORG_ADMIN],
      },
    };

    if (croppedImageFile) {
      const imageData = {
        fileName: croppedImageFile.file.name,
        fileType: `.${croppedImageFile.file.name.split(".").pop()}`,
      };

      getSignedUrl(imageData).then((res) => {
        uploadToS3(res.urls, croppedImageFile.file).then(() => {
          data["imageUrl"] = res.path;

          addAdmin(data).then(() => {
            history.goBack();
          });
        });
      });
    } else {
      addAdmin(data).then(() => {
        history.goBack();
      });
    }
  };

  /**
   * function to add existing user as admin
   * @param e: event from button click
   */
  const onUserAdd = (e) => {
    e.preventDefault();

    const data = {
      organizationId: location.state.orgIdHistory,
      headDoctor: true,
      userId: userid,
    };

    addAdminFromExistingUser(data).then(() => {
      history.goBack();
    });
  };

  /**
   * function to handle cancel add
   */
  const handleCancel = () => {
    history.goBack();
  };

  return (
    <Box className={classes.outerContainer}>
      <AppBreadCrumb>
        {getBreadcrumbData(currentUrlPath).map((crumb, index) => (
          <Box
            key={index}
            component={NavLink}
            exact
            to={{
              pathname: crumb.path,
              state: {
                orgIdHistory: location.state && location.state.orgIdHistory,
                orgNameHistory: location.state && location.state.orgNameHistory,
              },
            }}
            className={classes.breadcrumbItem}
            activeClassName={classes.activeBreadcrumbItem}
          >
            {crumb.icon && (
              <Icon className={classes.breadcrumpIcon}>{crumb.icon}</Icon>
            )}
            <Box className={classes.breadcrumpLabel}>{crumb.name}</Box>
          </Box>
        ))}
      </AppBreadCrumb>

      <Box mt={2}>
        <ValidatorForm onSubmit={userid ? onUserAdd : onAdd}>
          <AdminForm
            classes={classes}
            isDisabled={isDisabled}
            croppedImageFile={croppedImageFile}
            onImageCrop={onImageCrop}
            email={email}
            firstname={firstname}
            handleSearchUserByEmail={handleSearchUserByEmail}
            setEmail={setEmail}
            setFirstname={setFirstname}
            lastname={lastname}
            rowImageFile={rowImageFile}
            setRowImageFile={setRowImageFile}
            setLastname={setLastname}
            phone={phone}
            setPhone={setPhone}
            setCropper={setCropper}
            setShowImageEditor={setShowImageEditor}
            showImageEditor={showImageEditor}
          />

          <Box className={classes.formBottomContainer}>
            <Box component={Card} raised className={classes.buttonsContainer}>
              <Box>
                <Button
                  variant="outlined"
                  color="primary"
                  disableElevation={true}
                  onClick={() => setOpenCancelConfirmation(true)}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  disableElevation={true}
                  type="submit"
                  classes={{root: classes.savebutton}}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </ValidatorForm>
      </Box>

      <Box>
        <ConfirmationDialog
          open={openCancelConfirmation}
          setOpen={setOpenCancelConfirmation}
          title="Cancel"
          message="Are you sure you want to cancel?"
          onConfirm={handleCancel}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    addAdmin: (data) => {
      return dispatch(addAdminRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    addAdminFromExistingUser: (data) => {
      return dispatch(addAdminFromExistingUserRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getSignedUrl: (data) => {
      return dispatch(getSignedUrlRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    uploadToS3: (url, file) => {
      return dispatch(uploadToS3Request(url, file)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getUserByEmail: (email) => {
      return dispatch(getUserByEmailRequest(email)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminFormForOrgAdmin);
